import { render, staticRenderFns } from "./ClassAvatar.vue?vue&type=template&id=18d04354&scoped=true"
import script from "./ClassAvatar.vue?vue&type=script&lang=js"
export * from "./ClassAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d04354",
  null
  
)

export default component.exports